import { Component, OnInit, AfterViewInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import Swal from "sweetalert2";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { Utilities } from 'src/app/models/utilities';
import { CustomerService } from "src/app/services/customer.service";
import { RateUploadService } from "src/app/services/operations/rateupload.service";
import { RateBandsService } from "src/app/services/ratebands.service";
import { ColumnApi, GridApi, GridOptions, GridReadyEvent } from "ag-grid-community";
import { AppCoreService } from "src/app/services/app-core.service";
import { ProductService } from "src/app/services/products.service";
import { EditDeleteActionsRenderer } from "../../../shared/ag-grid/cell-renderers/edit-delete.component";
import { TaxesService } from "src/app/services/system-config/taxes/taxes.service";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { EditTaxesComponent } from "../edit/edit.component";
import { Title } from "@angular/platform-browser";
import { CompanyService } from "src/app/services/company.service";
import { VendorService } from "src/app/services/vendor.service";

@Component({
  selector: 'app-add',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.scss'],
})
export class AddTaxesComponent implements OnInit, AfterViewInit {
  taxesForm: FormGroup;
  permConfig = {
    isViewAllowed: false,
    isAddAllowed: false,
    isEditAllowed: false,
    isDeleteAllowed: false
  };
  isFormSubmitted: boolean;
  showModel = false;
  rateTypeList = [];
  rateCategoriesList = [];
  rateBandList: []
  vendorList: any[] = [];
  customerList = [];
  companyList: any[] = [];
  // originList: any;
  // destinationList: any;
  // rateCategoryCode: any;
  taxData: any;
  rateDetailData: any;
  showDownloadBtn = false;
  showBands = false;
  showCustomer = false;
  showVendor = false;
  selectedFile: File | null = null;
  productList: [] = [];
  public context: any;
  private gridApi!: GridApi;
  private gridColumnApi!: ColumnApi;
  periodId: number; //ratePeriod table serial id 

  defaultColDef = {
    filter: true,
    sortable: true,
    resizable: false,
    flex: 1,
    minWidth: 120
  };

  gridOptions: GridOptions = {
    pagination: true,
    domLayout: 'autoHeight',
    paginationPageSize: 10
  }
  rowData: any[] = [];
  columnDefs = [
    { headerName: 'Rate Type', field: 'ratetype' },
    { headerName: 'Category', field: 'ratecategory' },
    { headerName: 'From Date', field: 'fromdate' },
    { headerName: 'To Date', field: 'todate' },
    { headerName: 'Band', field: 'rateband' },
    { headerName: 'Customer', field: 'customer', minWidth: 240 },
    { headerName: 'Vendor', field: 'vendor', minWidth: 140 },
    { headerName: 'Company', field: 'company', minWidth: 240 },
    { headerName: 'Product', field: 'product', minWidth: 180 },
    { headerName: 'IGST', field: 'igst', minWidth: 80, pinned: 'right' },
    { headerName: 'CGST', field: 'cgst', minWidth: 80, pinned: 'right' },
    { headerName: 'SGST', field: 'sgst', minWidth: 80, pinned: 'right' },
    {
      headerName: 'Actions',
      field: 'id',
      cellRenderer: EditDeleteActionsRenderer,
      cellClass: "actions-button-cell",
      cellStyle: { "overflow": 'visible' },
      colId: 'params',
      editable: false,
      sortable: false,
      filter: false,
      minWidth: 100,
      pinned: 'right'
    },
  ];
  ngbModalOptions: NgbModalOptions = {
    ariaLabelledBy: 'modal-basic-title',
    size: 'lg',
    backdrop: 'static',
    keyboard: false,
    centered: true
  };
  showCategory = false;
  currentDate: any;
  productTypeList: any[] = [];
  useEnterKey: any;
  constructor(
    private formBuilder: FormBuilder,
    private ngxLoaderService: NgxUiLoaderService,
    private utilities: Utilities,
    private appCoreService: AppCoreService,
    private customerService: CustomerService,
    private companyService: CompanyService,
    private productService: ProductService,
    private rateUploadService: RateUploadService,
    private rateBandsService: RateBandsService,
    private taxesService: TaxesService,
    public modalService: NgbModal,
    private vendorService: VendorService,
    private titleService: Title
  ) {
    titleService.setTitle('Taxes');
    this.context = { componentParent: this };
  }

  ngOnInit(): void {
    this.currentDate = this.utilities.FormatDateWithTime();
    //main form
    this.taxesForm = this.formBuilder.group({
      ddlRateType: [null, Validators.required],
      ddlRateCategory: [null],
      ddlRateBand: [null],
      ddlCustomer: [null],
      ddlVendor: [null],
      ddlCompany: [null],
      ddlProduct: [null],
      txtIGST: [null, Validators.required],
      txtCGST: [null, Validators.required],
      txtSGST: [null, Validators.required],
      txtFromDate: [this.currentDate.dateString, Validators.required],
      txtToDate: [this.currentDate.dateString, Validators.required],
    });
    this.checkPermission();
    if (this.permConfig.isViewAllowed) {
      this.getAllTaxes();
      this.getAllRateTypes();
      this.getAllProducts();
      this.getAllCustomers();
      this.getAllCompanies();
      this.getAllRateBands();
      this.getAllVendors();
    }
  };

  ngAfterViewInit(): void {
    this.useEnterKey ? this.utilities.focusFirstElement(this.taxesForm) : null;
  }

  checkPermission(): any {
    const userData = this.appCoreService.GetUserData();
    this.useEnterKey = !userData.metaInfo.tabbasedtemplate;
    const permission = userData.config.filter(x => x.categoryname === 'Taxes');
    if (permission.length) {
      this.permConfig.isViewAllowed = permission[0].view;
      this.permConfig.isAddAllowed = permission[0].add;
      this.permConfig.isEditAllowed = permission[0].edit;
      this.permConfig.isDeleteAllowed = permission[0].delete;
    }
  }

  openChargeDetailModel(taxData) {
    const modalRef = this.modalService.open(EditTaxesComponent, this.ngbModalOptions);
    modalRef.componentInstance.taxData = taxData[0];
    modalRef.result.then(
      (result) => {
        if (result == 'Save Click') {
          this.getAllTaxes();
        }
      },
      (reason) => {
        if (reason == 'Cross click') {
        }
      }
    );
  }

  setDefaultFields() {
    this.isFormSubmitted = false;
    this.taxesForm.reset();
    this.taxesForm.get('txtFromDate').setValue(this.currentDate.dateString);
    this.taxesForm.get('txtToDate').setValue(this.currentDate.dateString);
  }

  getAllRateTypes() {
    this.rateUploadService.GetAllRateTypes().subscribe(res => {
      try {
        if (res && res.success) {
          this.rateTypeList = res.data.types;
          // this.rateCategoriesList = res.data.categories.filter(x => x.ratecategory == 'Customer');
          this.rateCategoriesList = res.data?.categories?.filter(
            (item) => item.ratecategory !== 'Country Rate' && item.ratecategory !== 'Zone Rate'
          ) || [];
        }
      } catch (error) {
        console.error(error);
      }
    })
  }

  getAllRateBands() {
    try {
      this.rateBandsService.GetAll().subscribe((res) => {
        if (res && res.success) {
          this.rateBandList = res.data;
        }
      })
    } catch (error) {
      console.error(error);
    }
  }

  getAllCustomers() {
    try {
      this.customerService.GetAll({ scid: this.appCoreService.GetUserData().selectedServiceCenter, isactive: true }).subscribe((res) => {
        if (res && res.success) {
          this.customerList = res.data;
          // console.log(this.customerList);

        }
      })
    } catch (error) {
      console.error(error);
    }

  }

  getAllVendors() {
    try {
      this.vendorService.GetAll({ isactive: true }).subscribe((res) => {
        if (res && res.success) {
          this.vendorList = res.data;
        }
      })
    } catch (error) {
      console.error(error);
    }
  }

  getAllCompanies() {
    try {
      this.ngxLoaderService.start();
      this.companyService.GetAll({ isactive: true }).subscribe((res) => {
        if (res && res.success) {
          this.ngxLoaderService.stop();
          this.companyList = res.data;
        } else {
          this.ngxLoaderService.stop();
        }
      });
    } catch (e) {
      console.error(e);
      this.ngxLoaderService.stop();
    }
  }

  getAllProducts() {
    try {
      this.productService.GetAll({ isactive: true }).subscribe((res) => {
        if (res?.success) {
          this.productList = res.data;
        }
      })
    } catch (error) {
      console.error(error);
    }

  }

  getAllRatePeriod() {
    this.ngxLoaderService.start();
    this.rateUploadService.GetAllRatePeriods().subscribe(res => {
      try {
        if (res && res.data) {
          this.ngxLoaderService.stop();
          for (const item of res.data) {
            item.fromdate = this.utilities.formatDate(item.fromdate).dateString;
            item.todate = this.utilities.formatDate(item.todate).dateString;
          }
          this.rowData = res.data;
          // console.log(res.data);
        } else {
          this.ngxLoaderService.stop();
        }
      } catch (error) {
        this.ngxLoaderService.stop();
      }
    })


  }

  onChangeRateType() {
    const selectedRateType = this.rateTypeList.find(type => type.id === this.taxesForm.controls.ddlRateType.value)?.ratetype; // Expecting descriptive values like "Tariff", "Band", "Customer"
    const selectedCategoryid = this.taxesForm.get('ddlRateCategory')?.value;
    
    // Default case - hide all if none of the specific types are selected
    this.showCategory = false;
    this.showBands = false;
    this.showCustomer = false;
    this.showVendor = false;

    // Clear validators for all controls initially
    this.taxesForm.controls.ddlRateCategory.clearValidators();
    this.taxesForm.controls.ddlRateBand.clearValidators();
    this.taxesForm.controls.ddlCustomer.clearValidators();
    this.taxesForm.controls.ddlVendor.clearValidators();

    // Apply specific logic based on rate type
    if (selectedRateType === 'Tariff') {
      // Tariff
      this.showCategory = false;
      this.showBands = false;
      this.showCustomer = false;
      this.showVendor = false;
      this.taxesForm.controls.ddlRateCategory.reset();
      this.taxesForm.controls.ddlRateBand.reset();
      this.taxesForm.controls.ddlCustomer.reset();
      this.taxesForm.controls.ddlVendor.reset();
      // this.taxesForm.controls.ddlRateCategory.disable();
    } else if (selectedRateType === 'Bands') {
      // band
      this.showCategory = false;
      this.showBands = true;
      this.showCustomer = false;
      this.showVendor = false;
      this.taxesForm.controls.ddlRateBand.setValidators([Validators.required]);
      this.taxesForm.controls.ddlRateCategory.reset();
      // this.taxesForm.controls.ddlRateCategory.disable();
    } else if (selectedRateType === 'Contract') {
      // Contract
      this.showCategory = true;
      // this.showBands = false;
      // this.showCustomer = true;
      if (selectedCategoryid === 1) {
        // this.taxesForm.get('ddlRateCategory')?.setValue(this.rateCategoriesList[0].id);

        this.showCustomer = true;
        this.showBands = false;
        this.showVendor = false;
        this.taxesForm.controls.ddlVendor.reset();
        this.taxesForm.controls.ddlVendor.clearValidators();
        this.taxesForm.controls.ddlCustomer.setValidators([Validators.required]);

      } else if (selectedCategoryid === 2) {
        // Vendor
        this.showCustomer = false;
        this.showVendor = true;
        this.taxesForm.controls.ddlCustomer.reset();
        this.taxesForm.controls.ddlCustomer.clearValidators();
        this.taxesForm.controls.ddlVendor.setValidators([Validators.required]);
      } else {
        this.showCustomer = false;
        this.showVendor = false;
      }
      this.taxesForm.controls.ddlRateCategory.setValidators([Validators.required]);
      this.taxesForm.controls.ddlCustomer.setValidators([Validators.required]);
    } else {
      // Handle unexpected values if needed
      console.warn('Unexpected rate type selected:', selectedRateType);
    }

    // Update validity for controls
    this.taxesForm.controls.ddlRateCategory.updateValueAndValidity();
    this.taxesForm.controls.ddlRateBand.updateValueAndValidity();
    this.taxesForm.controls.ddlCustomer.updateValueAndValidity();
    this.taxesForm.controls.ddlVendor.updateValueAndValidity();

    // Set form submitted flag to false
    this.isFormSubmitted = false;
  }


  onChangeRateCategory() {
    const selectedCategory = this.taxesForm.get('ddlRateCategory').value;
    // console.log('selectedCategory: ', selectedCategory);
    // this.showBands = false;
    if (selectedCategory === 1) {
      // Customer
      this.showCustomer = true;
      this.showVendor = false;
      this.taxesForm.controls.ddlVendor.reset();
      this.taxesForm.controls.ddlVendor.clearValidators();
      this.taxesForm.controls.ddlCustomer.setValidators([Validators.required]);

    } else if (selectedCategory === 2) {
      // Vendor
      this.showCustomer = false;
      this.showVendor = true;
      this.taxesForm.controls.ddlCustomer.reset();
      this.taxesForm.controls.ddlCustomer.clearValidators();
      this.taxesForm.controls.ddlVendor.setValidators([Validators.required]);
    } else {
      this.showCustomer = false;
      this.showVendor = false;
    }
  }

  addTaxes() {
    this.isFormSubmitted = !this.showModel ? true : false;
    if (!this.permConfig.isAddAllowed) {
      this.warningDialog('No Access to Add.');
      return;
    }
    this.taxesForm.removeControl('taxesEditForm');
    const invalidControls = Object.keys(this.taxesForm.controls).filter(controlName => this.taxesForm.get(controlName)?.invalid);

    if (invalidControls.length > 0) {
      // console.log('Invalid controls:', invalidControls);
      // You can handle the invalid controls here
    } else {
      // console.log('All controls are valid.');
    }
    try {
      if (this.taxesForm.valid && this.permConfig.isAddAllowed && this.isFormSubmitted) {
        const rateTypeId = this.taxesForm.get('ddlRateType').value;
        const rateCategoryId = this.taxesForm.get('ddlRateCategory').value;
        let requestObj = {
          ratetypeid: rateTypeId,
          ratecategoryid: rateCategoryId,
          ratebandid: this.taxesForm.get('ddlRateBand').value,
          fromdate: this.taxesForm.get('txtFromDate').value,
          todate: this.taxesForm.get('txtToDate').value,
          customerid: this.taxesForm.get('ddlCustomer').value,
          vendorid: this.taxesForm.get('ddlVendor').value,
          productcode: this.taxesForm.get('ddlProduct').value,
          companyid: this.taxesForm.get('ddlCompany').value,
          igst: this.taxesForm.get('txtIGST').value,
          cgst: this.taxesForm.get('txtCGST').value,
          sgst: this.taxesForm.get('txtSGST').value,
        };

        this.taxesService.Add(requestObj).subscribe(res => {
          this.ngxLoaderService.start();
          if (res) {
            if (!res.success) {
              this.ngxLoaderService.stop();
              this.appCoreService.showMessage('This combination already exists !', 'Error', 'error')
            }
            if (res.success) {
              this.ngxLoaderService.stop();
              this.getAllTaxes();
              this.appCoreService.showMessage('Record Added Successfully')
              this.setDefaultFields();
            }
          }
        })
      }
    } catch (e) {
      console.error(e);
    }
  }

  getAllTaxes(refresh = false) {
    try {
      this.taxesService.GetAll({refresh: refresh}).subscribe(res => {
        if (res?.success) {
          this.rowData = res.data;
        }
      })
    } catch (error) {
    }
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
  }

  editAction(cell: any) {
    try {
      if (!this.permConfig.isEditAllowed) {
        this.warningDialog('No Access to Edit.')
      }
      else if (this.permConfig.isEditAllowed && cell) {
        //find the cell in rowData List
        this.isFormSubmitted = false;
        this.ngxLoaderService.start()
        this.taxesService.GetById(cell.id).subscribe(res => {
          if (res?.success) {
            this.ngxLoaderService.stop()
            this.taxData = res.data;
            this.openChargeDetailModel(res.data);
          }
        })
      }
    } catch (e) {
      console.error(e);
      this.ngxLoaderService.stop()
    }

  }

  //period**
  editPeriodAction(cell: any) {
    try {
      if (!this.permConfig.isEditAllowed) {
        this.warningDialog('No Access to Edit.')
      }
      else if (this.permConfig.isEditAllowed && cell) {
        this.isFormSubmitted = false;
        this.taxData = cell;
        this.showModel = true;
      }
    } catch (e) {
      console.error(e);
    }

  }

  async deleteAction(cell: any) {
    if (!this.permConfig.isDeleteAllowed) {
      this.warningDialog('No Access to Delete.');
    }
    else if (this.permConfig.isDeleteAllowed && cell && cell.id) {
      const confirmed = await this.openConfirmationDialog();
      if (confirmed) {
        try {
          this.taxesService.DeleteById(cell.id).subscribe(res => {
            if (res && res.success) {
              this.appCoreService.showMessage('Record deleted successfully');
              this.getAllTaxes(true);
            }
          });
        } catch (error) {
        }
      }
    }
  }

  async openConfirmationDialog() {
    const result = await Swal.fire({
      titleText: 'Confirmation',
      html: `<span>This action is irreversible.</span><br><span>Are you sure you want to delete?</span>`,
      icon: 'warning',
      confirmButtonText: 'Yes',
      showDenyButton: true,
      denyButtonText: 'No',
      allowEscapeKey: false,
      allowOutsideClick: false
    });
    if (result.isConfirmed) {
      return true;
    }
  }

  async successDialog(msg?: any) {
    const success = await Swal.fire({
      titleText: 'Success',
      text: msg,
      icon: 'success',
      confirmButtonText: 'Ok',
      allowEscapeKey: false,
      allowOutsideClick: false
    })
    if (success.isConfirmed) {
      this.getAllRatePeriod();
      this.isFormSubmitted = false;
      this.taxesForm.reset();
      this.taxesForm.controls.txtFromDate.setValue(this.currentDate.dateString);
      this.taxesForm.controls.txtToDate.setValue(this.currentDate.dateString);
    }
  }

  async warningDialog(msg?: any) {
    Swal.fire({
      titleText: 'Warning',
      text: msg,
      icon: 'warning',
      confirmButtonText: 'Ok',
      allowEscapeKey: false,
      allowOutsideClick: false
    })
  }

  onCloseEdit(e: any) {
    this.isFormSubmitted = false;
    this.showModel = false;
    this.resetForm();
  }
  onUpdatePeriod(e: any) {
    // this.taxData = false;
    this.getAllRatePeriod();
  }
  resetForm() {
    this.taxesForm.reset();
    this.taxesForm.get('txtFromDate').setValue(this.currentDate.dateString);
    this.taxesForm.get('txtToDate').setValue(this.currentDate.dateString);
    this.onChangeRateType();
    this.isFormSubmitted = false;
  }
}